export default "__VITE_ASSET__C13jCOIu__"